export enum ColorModule {
  RECO = '#EB2F96',
  LUCI = '#7849FF',
  SHERLOCK = '#13C2C2',
  WATSON = '#FA8C16',
  SETTINGS = '#1890FF',
  RUBY = '#EFBC9B',
  GAYA = '#9befe0',
  BUSY = '#006699',
  COMM = '#199a26',
  INCIDENT = '#2184c1',
  SUBSCRIPTION = '#eb8934',
  PATH_FINDER = '#7849FF',
  STRATEGY_BUILDER = '#C96D9C',
  DEFAULT = 'gray'
}
